// FormulaireWrapper.js - Version corrigée
import React from 'react';

// ✅ CORRECTION : Imports corrects avec les bons chemins
import FormulaireA from '../../pages/carrossier/FormulaireA';
import FormulaireB from '../../pages/carrossier/FormulaireB';

const FormulaireWrapper = ({ formType, productId, orderId, onComplete, produit, index }) => {
  console.log("🔍 FormulaireWrapper - Type reçu:", formType);
  console.log("🔍 FormulaireWrapper - Props:", { productId, orderId, produit, index });

  // Logique de sélection du formulaire basée sur le type
  const renderFormulaire = () => {
    switch (formType) {
      case 'TypeA':
      case 'typeA':
      case 'TYPEA':
        console.log("📋 Rendu FormulaireA (Type A)");
        return (
          <FormulaireA
            productId={productId}
            orderId={orderId}
            onComplete={onComplete}
            produit={produit}
            index={index}
          />
        );

      case 'TypeB':
      case 'typeB':
      case 'TYPEB':
      case 'TypeB_HUSKY_CleverSafe':
        console.log("📋 Rendu FormulaireB (Type B - HUSKY CLEVER SAFE)");
        return (
          <FormulaireB
            productId={productId}
            orderId={orderId}
            onComplete={onComplete}
            produit={produit}
            index={index}
          />
        );

      default:
        console.warn("⚠️ Type de formulaire non reconnu:", formType);
        return (
          <div className="max-w-4xl mx-auto p-6">
            <div className="bg-red-50 border border-red-200 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <span className="text-2xl">⚠️</span>
                <h3 className="text-lg font-semibold text-red-800">
                  Type de formulaire non reconnu
                </h3>
              </div>
              <p className="text-red-700 mb-4">
                Le type de formulaire "{formType}" n'est pas supporté.
              </p>
              <div className="bg-white rounded-lg p-4 border border-red-200">
                <p className="text-sm text-gray-600 mb-2">
                  <strong>Types supportés :</strong>
                </p>
                <ul className="text-sm text-gray-600 space-y-1 ml-4">
                  <li>• TypeA - Formulaire standard</li>
                  <li>• TypeB - Formulaire HUSKY CLEVER SAFE</li>
                </ul>
              </div>
              <button
                onClick={() => window.history.back()}
                className="mt-4 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
              >
                ← Retour
              </button>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="formulaire-wrapper">
      {renderFormulaire()}
    </div>
  );
};

export default FormulaireWrapper;